export default __webpack_public_path__ + "static/media/direct.deffd47b.svg";